import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiCart, mdiChevronDown, mdiChevronUp } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const MaterialSourcingMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (!user.equinor) {
      return null;
    }

    const canViewInternalQuotationDoubts = user.user_groups_names.includes(
      "Internal Quotation Interactions",
    );
    const canViewVbuyer = user.roles_names.includes("View Vbuyer");

    if (
      !(
        canViewInternalQuotationDoubts ||
        (canViewVbuyer &&
          (user.roles_names.includes("View Quotations") ||
            user.roles_names.includes("View Quotation Batches") ||
            user.roles_names.includes("Edit Quotation Batches") ||
            user.roles_names.includes("View Assisted Quotation")))
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="materialSourcing"
          onClick={() => handleClick("materialSourcing")}
          title={t("menu.materialSourcing.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiCart} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.materialSourcing.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={openSubmenu.materialSourcing ? mdiChevronUp : mdiChevronDown}
          />
        </ListItemButton>
        <Collapse
          in={openSubmenu.materialSourcing}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {!!(canViewVbuyer || canViewInternalQuotationDoubts) && (
              <HybridRouteListItemButtonLink
                caption="doubts"
                isReact={false}
                name="materialSourcing[doubts]"
                sx={{ pl: 4 }}
                title={t("menu.materialSourcing.submenu.doubts.title")}
                url={
                  canViewVbuyer
                    ? "/vbuyer/doubts"
                    : "/vbuyer/quotation_doubts/internal"
                }
              >
                <ListItemText
                  primary={t("menu.materialSourcing.submenu.doubts.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {canViewVbuyer && user.roles_names.includes("View Quotations") && (
              <HybridRouteListItemButtonLink
                caption="quotations"
                name="materialSourcing[quotations]"
                sx={{ pl: 4 }}
                title={t("menu.materialSourcing.submenu.quotations.title")}
                url="/vbuyer/quotations"
              >
                <ListItemText
                  primary={t("menu.materialSourcing.submenu.quotations.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {canViewVbuyer &&
              (user.roles_names.includes("View Quotation Batches") ||
                user.roles_names.includes("Edit Quotation Batches")) && (
                <HybridRouteListItemButtonLink
                  caption="quotation batches"
                  name="materialSourcing[quotationBatches]"
                  sx={{ pl: 4 }}
                  title={t(
                    "menu.materialSourcing.submenu.quotationBatches.title",
                  )}
                  url="/vbuyer/quotation_batches"
                >
                  <ListItemText
                    primary={t(
                      "menu.materialSourcing.submenu.quotationBatches.title",
                    )}
                    slotProps={{
                      primary: { sx: { fontSize: 14 } },
                    }}
                    sx={{ whiteSpace: "normal" }}
                  />
                </HybridRouteListItemButtonLink>
              )}

            {canViewVbuyer &&
              (user.roles_names.includes("View Quotations") ||
                user.roles_names.includes("View Assisted Quotation")) && (
                <HybridRouteListItemButtonLink
                  caption="issue purchase order"
                  name="materialSourcing[issuePurchaseOrder]"
                  sx={{ pl: 4 }}
                  title={t(
                    "menu.materialSourcing.submenu.issuePurchaseOrder.title",
                  )}
                  url="/vbuyer/quotations/issue_purchase_order"
                >
                  <ListItemText
                    primary={t(
                      "menu.materialSourcing.submenu.issuePurchaseOrder.title",
                    )}
                    slotProps={{
                      primary: { sx: { fontSize: 14 } },
                    }}
                    sx={{ whiteSpace: "normal" }}
                  />
                </HybridRouteListItemButtonLink>
              )}

            {canViewVbuyer && (
              <HybridRouteListItemButtonLink
                caption="quality checklists"
                name="materialSourcing[qualityChecklists]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.materialSourcing.submenu.qualityChecklists.title",
                )}
                url="/vbuyer/guides"
              >
                <ListItemText
                  primary={t(
                    "menu.materialSourcing.submenu.qualityChecklists.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
